import { useCallback } from "react";

import { Property } from "manager/interfaces/api";
import { NOTIFICATIONS } from "shared/config/constants";
import useModal from "shared/hooks/useModal";
import { openNotification } from "shared/utils/ui";

import {
  bulkGoLiveSkipOnlyMessage,
  partitionSetLiveSelection,
} from "./billingDisplay";
import BillingHistoryModal from "./BillingHistoryModal";
import CancelScheduledModalContainer from "./CancelScheduledModalContainer";
import CorrectGoLiveModalContainer from "./CorrectGoLiveModalContainer";
import EditBillableUnitsModalContainer from "./EditBillableUnitsModalContainer";
import SetLiveModalContainer from "./SetLiveModalContainer";
import StopBillingModalContainer from "./StopBillingModalContainer";

export const useBillingSectionActions = (onSuccess: () => void) => {
  const { openModalDialog } = useModal();

  const onSetLive = useCallback(
    (properties: Property[]) => {
      const { eligible, skipped } = partitionSetLiveSelection(properties);
      if (!eligible.length) {
        if (skipped.length) {
          openNotification(
            bulkGoLiveSkipOnlyMessage(skipped),
            NOTIFICATIONS.info
          );
        }
        return;
      }
      openModalDialog(SetLiveModalContainer, { properties, onSuccess });
    },
    [openModalDialog, onSuccess]
  );
  const onStop = useCallback(
    (property: Property) =>
      openModalDialog(StopBillingModalContainer, { property, onSuccess }),
    [openModalDialog, onSuccess]
  );
  const onCorrect = useCallback(
    (property: Property) =>
      openModalDialog(CorrectGoLiveModalContainer, { property, onSuccess }),
    [openModalDialog, onSuccess]
  );
  const onCancelScheduled = useCallback(
    (property: Property) =>
      openModalDialog(CancelScheduledModalContainer, { property, onSuccess }),
    [openModalDialog, onSuccess]
  );
  const onEditUnits = useCallback(
    (property: Property) =>
      openModalDialog(EditBillableUnitsModalContainer, { property, onSuccess }),
    [openModalDialog, onSuccess]
  );
  const onHistory = useCallback(
    (property: Property) => openModalDialog(BillingHistoryModal, { property }),
    [openModalDialog]
  );

  return {
    onSetLive,
    onStop,
    onCorrect,
    onCancelScheduled,
    onEditUnits,
    onHistory,
  };
};
